import React from 'react';
import styled, { css } from 'styled-components';

import { Theme } from '@desygner/ui-common-components';
import Icon from 'src/UI/Icon/Icon';
import { Actions, useViewport } from './ViewportProvider';

const ZoomWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 175px;
  padding: 4px 0;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 8px rgba(0,0,0,0.16);
  margin-right: 8px;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 2;
  margin: 8px;
`;

const ZoomButton = styled.div`
  flex: 1;
  font-size: 14px;
  line-height: 20px;
  height: 40px;
  min-width: 32px;
  border-radius: 4px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  margin: 0 4px;
  color: #200e32;
  outline: none;
  background: transparent;
  cursor: pointer;
  pointer-events: auto;
  font-weight: 600;

  :hover {
    background-color: ${({ theme }) => theme.Color.Brand.Lightest};
  }

  :active {
    background-color: ${({ theme }) => theme.Color.Brand.Light};
  }

  ${({ key }) => key === 'custom' && css`
    text-transform: capitalize;
  `}
`;

export default function ZoomButtons () {
  const { dispatch } = useViewport();

  const zoomOut = () => {
    return () => dispatch({ type: Actions.zoom_out });
  };
  const zoomFit = () => {
    return () => dispatch({ type: Actions.zoom_fit });
  };

  const zoomIn = () => {
    return () => dispatch({ type: Actions.zoom_in });
  };

  return (
    <ZoomWrapper>
      <ZoomButton onClick={zoomOut()}>
        <Icon name="editor-minus" size="medium" color={Theme.Color.Neutrals.Dark} />
      </ZoomButton>
      <ZoomButton onClick={zoomFit()}>
        Fit
      </ZoomButton>
      <ZoomButton onClick={zoomIn()}>
        <Icon name="editor-plus" size="medium" color={Theme.Color.Neutrals.Dark} />
      </ZoomButton>
    </ZoomWrapper>
  );
}
